import {
  Divider,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  VStack
} from '@chakra-ui/react';
import React, { FC, useContext } from 'react';
import { Cart } from '@app/screens/nft-marketplace/Cart/Cart';
import { useNftCartModal } from '@app/context/NftCartContext';

interface Props {
  isOpen: boolean;
}

export const CheckoutModal: FC<Props> = ({ isOpen }) => {
  const { toggleModal } = useNftCartModal();

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        toggleModal(false);
      }}
      isCentered
      motionPreset="slideInBottom"
      size="md"
    >
      <ModalOverlay />
      <ModalContent
        backgroundColor="black"
        sx={{ maxWidth: ['100vw', '859px'], padding: '32px' }}
      >
        <HStack justifyContent="space-between">
          <ModalHeader fontWeight="400" fontSize="24px" lineHeight="18px">
            Checkout
          </ModalHeader>
          <ModalCloseButton />
        </HStack>
        <Divider
          sx={{ margin: '28px 0', background: 'gray.15', height: '1px' }}
        />
        <ModalBody>
          <Cart />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
